define(function (require) {
    "use strict";

    var $ = require('jquery');

    var WidgetUtils = function (){

        var version = '1.0';

        return{

            highestZIndex : function (el) {

                var maxZ = Math.max.apply(Math, $.map(el.children(), function (e) {
                    if($(e).css('position') === 'absolute') {
                        return parseInt($(e).css('z-index'), 10) || 1;
                    }
                }));
                return Math.max(maxZ, 0);
            }
        };
    };

    return new WidgetUtils();
});